import * as React from "react";
import { AiOutlineBtn } from "./components/ui/AiOutlineBtn";
import { AiSpinner } from "./components/ui/AiSpinner";
import { IconFlask } from "./icons";

export type RunAnalysisButtonProps = {
  hasResults: boolean;
  loading: boolean;
  onClick: () => void;
};

/** Empty-state CTA only — Re-run lives in StatusHeader when results exist. */
export const RunAnalysisButton: React.FC<RunAnalysisButtonProps> = ({
  hasResults,
  loading,
  onClick,
}) => {
  if (hasResults) {
    return null;
  }

  const label = loading ? "Running…" : "Run AI analysis";

  return (
    <div className="ai-analysis__run-wrap">
      <AiOutlineBtn
        className="ai-analysis__run-btn"
        primary
        disabled={loading}
        onClick={onClick}
        aria-label={label}
      >
        {loading ? <AiSpinner size="sm" label="Running" /> : <IconFlask size={12} />}
        {label}
      </AiOutlineBtn>
    </div>
  );
};
